import { theme } from 'styled-tools';
import styled from './styled.js';
import as from './as.js';
import Hidden from './Hidden.js';
import { a as OverlayContainer, b as OverlayToggle, c as OverlayShow, d as OverlayHide } from './chunk-c23ea417.js';
import 'styled-components';
import './chunk-fb907809.js';
import '@emotion/is-prop-valid';
import 'react';
import 'hoist-non-react-statics';
import 'react-dom';
import 'prop-types';
import './chunk-a44fd1b3.js';
import './chunk-a7ce379e.js';
import './chunk-d8771a86.js';
import './Box.js';
import './chunk-ac382c96.js';
import 'constate';
import './chunk-6133b9c9.js';

var Overlay = styled(Hidden).withConfig({
  displayName: "Overlay",
  componentId: "pwhe8a-0"
})(["position:fixed;z-index:19900410;left:50%;top:50%;", ";"], theme("Overlay"));
Overlay.defaultProps = {
  role: "dialog",
  "aria-modal": true,
  hideOnEsc: true,
  translateX: "-50%",
  translateY: "-50%",
  defaultSlide: "top",
  opaque: true,
  palette: "background",
  tone: -1
};
var Overlay$1 = as("div")(Overlay);

Overlay$1.Container = OverlayContainer;
Overlay$1.Toggle = OverlayToggle;
Overlay$1.Show = OverlayShow;
Overlay$1.Hide = OverlayHide;

export default Overlay$1;
